import { render, staticRenderFns } from "./NewModal.vue?vue&type=template&id=079431c3&"
import script from "./NewModal.vue?vue&type=script&lang=ts&"
export * from "./NewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports